import * as React from 'react'

import { RowData, Table } from '@tanstack/react-table'

export const BAND_ROW_MIN_HEIGHT = 32

interface IBandRowProps<TData extends RowData> {
  table: Table<TData>
  children: React.ReactNode
}

// Full-width band/group header row for SharedVirtualTable's manual band path.
// Owns the gridcell + colspan + total-width sizing so the a11y and layout
// contract lives in one place across consumers; each consumer's renderRow
// supplies only the band's inner content.
export default function BandRow<TData extends RowData>({
  table,
  children,
}: IBandRowProps<TData>): React.ReactElement {
  const totalSize = table.getTotalSize()

  return (
    <div
      role="gridcell"
      aria-colindex={1}
      aria-colspan={table.getVisibleLeafColumns().length}
      className="tw:relative tw:flex tw:items-center tw:bg-sidebar tw:select-none tw:border-0 tw:border-b tw:border-solid tw:border-input-soft"
      style={{
        minHeight: BAND_ROW_MIN_HEIGHT,
        width: totalSize,
        minWidth: totalSize,
        maxWidth: totalSize,
      }}
    >
      {children}
    </div>
  )
}
